import React from 'react';

import { FormBlock } from './styles/FormBlock';
import { StyledPersonProspectRegistrationForm } from './styles/ProspectRegistrationForm';

function OpenForm(props) {
  return (
    <FormBlock>
      <StyledPersonProspectRegistrationForm
        isOpenForm
        {...props}
      />
    </FormBlock>
  );
}

export default OpenForm;
